import teamSetupPickerStore from "../store/store";
import { mutatorAction } from "satcheljs";
import { ProvisionScheduleMember } from "../store/schema/TeamSetupPickerStore";

export default mutatorAction('SET_TEAM_SETUP_MEMBERS', function setTeamSetupMembers(members: ProvisionScheduleMember[]) {
    if (teamSetupPickerStore.teamSetupInfo) {
        teamSetupPickerStore.teamSetupInfo.members = members;
    }
});
